import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-agent-settings-phone-outbound-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAgentSettingsPhoneOutboundIconProps extends SvgIconProps {}

export function CcfAgentSettingsPhoneOutboundIcon(
  props: CcfAgentSettingsPhoneOutboundIconProps
) {
  return (
    <SvgIcon
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 25 25"
        {...props}
      >
        <path
          d="M20.4337 14.8604C20.4337 14.8604 19.7294 15.9622 19.667 16.0556C19.6046 16.1489 19.4655 16.4257 18.8094 16.239C17.2963 15.6699 15.9586 14.7357 14.9234 13.5252C13.6996 12.4677 12.7669 11.132 12.2093 9.63834C12.022 8.98188 12.2991 8.84614 12.3922 8.78039C12.4853 8.71463 13.5871 8.01046 13.5871 8.01046C14.3286 7.57565 13.4896 5.71657 12.1381 4.82149C11.1403 4.15973 10.7021 4.22548 10.2827 4.55106C9.59942 5.0982 8.9884 5.72473 8.46338 6.4165C8.19754 6.78763 8.08391 7.2413 8.14465 7.68912C8.36379 9.10431 8.86924 10.4638 9.63204 11.6894C10.4919 13.1457 11.5454 14.4863 12.7657 15.677C13.9449 16.8883 15.2852 17.9425 16.7514 18.8118C17.965 19.5701 19.3283 20.0757 20.7546 20.2965C21.2055 20.3562 21.6626 20.242 22.0273 19.9784C22.7229 19.4478 23.3483 18.8362 23.8893 18.1575C24.2179 17.7333 24.2781 17.3006 23.6177 16.3016C22.7272 14.9569 20.8685 14.1191 20.4337 14.8604Z"
          fill="#5C2B83"
        ></path>
        <path
          d="M2.31887 17.5636C2.31887 18.1159 2.76658 18.5636 3.31887 18.5636C3.87115 18.5636 4.31887 18.1159 4.31887 17.5636V11.3634H6.24837C6.48739 11.3634 6.63042 11.0975 6.4987 10.8981L3.5589 6.44663C3.43964 6.26604 3.17421 6.2673 3.05667 6.44902L0.17726 10.9004C0.048142 11.1001 0.191424 11.3634 0.429155 11.3634H2.31887V17.5636Z"
          fill="#5C2B83"
        ></path>
    </SvgIcon>
  );
}

export default CcfAgentSettingsPhoneOutboundIcon;
